import React from 'react';
import PropTypes from 'prop-types';

import {Translate, translate} from 'views/module';

import PillDropdown from './PillDropdown';

const CallStatusDropdown = (props) => {
  const {selectedStatus, setSelectedStatus} = props;

  const statuses = Object.entries(translate('client.CallStatus'));
  const statusData = translate(`client.CallStatus.${selectedStatus}`);

  return (
    <PillDropdown
      backgroundColor={statusData.Color || 'transparent'}
      borderColor={statusData.ColorBorder || statusData.Color || 'transparent'}
      label={<Translate expression={`client.CallStatus.${selectedStatus}.Title`} />}
      menuLabel={translate('client.ClientDetail.Status.Metrics.IntroCall')}
      onOpenChange={props.onOverlayChange}
      onOptionSelect={(nextStatus) => {
        if (!nextStatus || nextStatus === selectedStatus) {
          return;
        }

        setSelectedStatus(nextStatus);
      }}
      options={statuses}
      selectedValue={selectedStatus}
      textColor={statusData.ColorText || '#000000'}
    />
  );
};

CallStatusDropdown.propTypes = {
  onOverlayChange: PropTypes.func,
  selectedStatus: PropTypes.string.isRequired,
  setSelectedStatus: PropTypes.func.isRequired,
};

export default CallStatusDropdown;
